import { combineReducers } from "redux";

import benefits from "./benefits";
import history from "./history";

export default combineReducers({
  benefits,
  history,
});
